/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BiCameraMovie } from 'react-icons/bi';
import Delete from '../Buttons/delete';
import { openModal } from '../../actions/modalActions';
import modalTypes from '../../constants/modalTypes';

class AttachmentList extends React.Component {
  constructor(props) {
    super(props);
    this.renderAttachment = this.renderAttachment.bind(this);
  }

  handleDelete = (attachmentId, index = -1) => {
    const actions = {
      confirm: {
        name: 'Confirm',
        function: () => this.props.onDelete(attachmentId, index)
      }
    };
    const message = 'Are you sure you want to delete this attachment?';
    this.props.openModal(
      modalTypes.message,
      {
        message,
        actions,
        closeButtonTitle: 'Cancel'
      },
      'confirm'
    );
  };

  attachmentPreview = (attachment) => {
    const file = attachment.droppedFile;
    const contentType = file.type;
    if (contentType.match(/image/))
      return attachment.droppedFileUrl;

    const thumbnail = `${process.env.HOST_BASE_URL}/images/attachments/icon.thumb.${contentType.replaceAll('/','.')}.png`;
    const request = new XMLHttpRequest(); 
    request.open('HEAD', thumbnail, false); 
    request.send(); 
 
    if (request.status == '200')
      return thumbnail; 
    else
      return `${process.env.HOST_BASE_URL}/images/attachments/icon.thumb.missing.png`;
  }

  // this function is used for existing workpackages
  renderAttachment(attachment) {
    return (
      <div key={`attachment-${attachment.id}`} className="attachment">
        <a
          id={`attachment-${attachment.id}`}
          href={attachment.download_url}
          download={attachment.file_name}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            id={`attachment-img-${attachment.id}`}
            src={attachment.thumbnail}
            alt={attachment.short_name}
            data-toggle="tooltip"
            title={attachment.file_name}
          />
          {attachment.content_type.includes('video') ? (
            <BiCameraMovie
              size="3.0em"
              color="#9797ce"
              className="attachment-play-icon"
            />
          ) : null}
        </a>
        {this.props.allowDelete && (
          <Delete
            handleClick={() => this.handleDelete(attachment.id)}
            btnClass="detail-delete"
          />
        )}
      </div>
    );
  }

  // this function is used for when creatng new workpackages
  renderPreview(attachment, index) {
    return (
      <div key={`attachment-${index}`} className="attachment">
        <a
          href={attachment.droppedFileUrl}
          download={attachment.droppedFile.name}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={this.attachmentPreview(attachment)}
            alt={attachment.name}
            data-toggle="tooltip"
            title={attachment.name}
          />
        </a>
        {this.props.allowDelete && (
          <Delete
            handleClick={() => this.handleDelete(null, index)}
            btnClass="detail-delete"
          />
        )}
      </div>
    );
  }

  render() {
    const preview = this.props.list.preview || false;
    const { attachments } = this.props.list;
    return (
      <div className="attachment-list">
        {attachments &&
          !preview &&
          attachments.map((attachment) => this.renderAttachment(attachment))}
        {attachments &&
          preview &&
          attachments.map((attachment, index) =>
            this.renderPreview(attachment, index)
          )}
      </div>
    );
  }
}

AttachmentList.propTypes = {
  list: PropTypes.object,
  onDelete: PropTypes.func
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(AttachmentList);
